import angular from 'angular';
import uiRouter from 'angular-ui-router';
import galleryComponent from './gallery.component';

let galleryModule = angular.module('gallery', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard.detail.gallery', {
    url: '/gallery',
    component: 'gallery',
    params: {
      item: null,
    }
  });
})

.component('gallery', galleryComponent)

.name;

export default galleryModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/gallery/gallery.js